import * as $ from 'jquery';

const keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
  e = e || window.event;
  
  if (!window.isScrollBlocked) {
    if (e.preventDefault) { e.preventDefault(); }
    e.returnValue = false;
  }
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

export function disableScroll() {
  const body = $('body'); // '0' to assign the first (and only `HTML` tag)
  body.addClass('ios-fix');
  // blockScroll();
//   var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
//   root.className += " noscroll";
//   document.body.className += " noscroll";
//     // document.addEventListener('touchstart', preventDefault, false);
//   if (window.addEventListener) // older FF
//       window.addEventListener('DOMMouseScroll', preventDefault, false);
//   window.onwheel = preventDefault; // modern standard
//   window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
//   window.ontouchmove  = preventDefault; // mobile
//   document.onkeydown  = preventDefaultForScrollKeys;
}
export function disableScrollJs() {
  const root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
  root.className += ' noscroll';
  document.body.className += ' noscroll';
  // document.addEventListener('touchstart', preventDefault, false);
  if (window.addEventListener) // older FF
  { window.addEventListener('DOMMouseScroll', preventDefault, false); }
  window.addEventListener('touchmove', preventDefault, {passive: false}); // android
  // document.body.addEventListener('touchstart', preventDefault, {passive: false});
  window.onwheel = preventDefault; // modern standard
  window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
  // window.ontouchmove  = preventDefault; // mobile
  document.onkeydown = preventDefaultForScrollKeys;
  window.isScrollBlocked = true;
}
 
export function enableScroll() {
  const body = $('body');// document.getElementsByTagName('body' )[0]; // '0' to assign the first (and only `HTML` tag)
  body.removeClass('ios-fix');
//   var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
//   root.className = root.className.replace(/noscroll/, '');
//     // document.removeEventListener('touchstart', preventDefault, false);
//     const bodyClass = document.body.className.replace(/noscroll/, '');
//     document.body.className = bodyClass;
//     if (window.removeEventListener)
//         window.removeEventListener('DOMMouseScroll', preventDefault, false);
//     window.onmousewheel = document.onmousewheel = null;
//     window.onwheel = null;
//     window.ontouchmove = null;
//     document.onkeydown = null;
}

export function enableScrollJs() {
  const root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
  root.className = root.className.replace(/noscroll/, '');
  document.removeEventListener('touchstart', preventDefault, false);
  const bodyClass = document.body.className.replace(/noscroll/, '');
  document.body.className = bodyClass;
  if (window.removeEventListener) { window.removeEventListener('DOMMouseScroll', preventDefault, false); }
  window.removeEventListener('touchmove', preventDefault, {passive: false}); // android
  window.onmousewheel = document.onmousewheel = null;
  window.onwheel = null;
  document.onkeydown = null;
  window.isScrollBlocked = false;
}

export const isBottom = () => (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100;

export function disableBodyOverflow() {
  document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
}

export function enableBodyOverflow() {
  document.getElementsByTagName('html')[0].style.overflowY = 'auto';
}



// WEBPACK FOOTER //
// ./src/helpers/scroll.js